import { render, staticRenderFns } from "./ConnectCourseSlidebar.vue?vue&type=template&id=6f105d2f"
import script from "./ConnectCourseSlidebar.vue?vue&type=script&lang=js"
export * from "./ConnectCourseSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports